// extracted by mini-css-extract-plugin
export var markdown = "_sx-0";
export var tableWrapper = "_sx-1";